import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, styled } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import Loading from '../components/loading';
import api from "../api/api";
import { useNavigate } from 'react-router-dom';

const VisuallyHiddenInput = styled('input')({
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1,
});

function TermsModal({ open, onClose, onSave, currentTerm }) {

  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);

  const isEditing = !!currentTerm;

  useEffect(() => {
    if (open && isEditing) {
      setDescription(currentTerm.descricao);
    }
    if (!open || !isEditing) {
      setDescription('');
      setFile(null);
    }
  }, [open, currentTerm, isEditing]);

  const fileChange = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile && uploadedFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(uploadedFile);
    } else {
      setFile(null);
      console.error("Tipo de arquivo inválido. Apenas .docx é permitido.");
    }
  };

  const saveTerm = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('description', description);
    if (file) {
      formData.append('file', file);
    }

    const headers = {
      Authorization: sessionStorage.getItem('token'),
    };

    api.post("/terms", formData, {
      headers
    }).then((returnFromApi) => {
      onSave(returnFromApi);
    }).catch((returnFromApi) => {
      console.error("ops! ocorreu um erro" + returnFromApi);
      if (returnFromApi.response?.status === 401) {
        navigate("/expired-session");
      }
      onSave(returnFromApi);
    });
  };


  const closeModal = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={closeModal} fullWidth maxWidth="sm">
      
      <Loading isToHidden={isLoading === false} />

      <DialogTitle>{isEditing ? 'Editar Termo' : 'Cadastrar Novo Termo'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="descricao"
          label="Descrição do Termo"
          type="text"
          fullWidth
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ mb: 3, mt: 1 }}
        />

        <Button
          component="label"
          role={undefined}
          variant="outlined"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          fullWidth
        >
          {file ? file.name : (isEditing ? 'Substituir Termo (.docx)' : 'Fazer Upload do Termo (.docx)')}
          <VisuallyHiddenInput
            type="file"
            accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            onChange={fileChange}
          />
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Cancelar</Button>
        <Button
          onClick={saveTerm}
          variant="contained"
          disabled={!description || (!file && !isEditing)}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TermsModal;